<template>
  <div>
    <a-card style="margin-top:20px;">
      <div class="text-right">
        <a-button type="primary" icon="plus" @click="showModal">
          上传新文件
        </a-button>
      </div>
      <TableView
        ref="table"
        :columns="columns"
        :pagination="pageData"
        :data="tableData"
        :loading="loading"
        :scroll="scroll"
        @handlePagination="handlePagination"
      >
        <!--操作 slot-->
        <template v-slot:action="{ tableRow }">
          <a
            href="javascript:void(0)"
            @click="_download(tableRow.id)"
            :disabled="tableRow.url == '' ? true : false"
          >
            下载
          </a>
          <a-divider type="vertical" />
          <a-popconfirm
            placement="leftTop"
            ok-text="确定"
            cancel-text="取消"
            title="确定删除此信息?"
            @confirm="() => handleDel(tableRow.id)"
          >
            <a-icon slot="icon" type="question-circle-o" class="icon-color" />
            <a href="javascript:void(0)">
              删除
            </a>
          </a-popconfirm>
        </template>
      </TableView>
    </a-card>

    <a-modal
      title="上传新文件"
      :visible="visible"
      destroyOnClose
      @ok="handleSubmit"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <a-form :form="form">
        <a-form-item label="选择文件">
          <a-upload
            multiple
            :beforeUpload="handleBeforeUpload"
            :default-file-list="defaultFileList"
            :fileList="fileList"
            :remove="handleRemove"
            @change="handleFileChange"
          >
            <a-button>
              <a-icon type="upload" />
              {{ btnText }}
            </a-button>
          </a-upload>
        </a-form-item>
        <a-form-item label="备注(100个字符以内)">
          <a-textarea
            :maxLength="100"
            :auto-size="{ minRows: 3, maxRows: 5 }"
            allowClear
            v-decorator="$decorator('remark', '', [{ required: false }])"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { TableView } from 'lxfintech-fe'
import {
  getAttachment,
  downloadRequest,
  deleteRequest,
  addDocument,
} from './api'
import { mapGetters } from 'vuex'
import { LOGIN_EXPIRED } from 'config/index'
import storage from 'good-storage'
import mixin from './mixin'
export default {
  mixins: [mixin],
  components: {
    TableView,
  },
  computed: {
    ...mapGetters('app', ['company']),
    ...mapGetters('user', ['token']),
  },
  data() {
    return {
      loading: '',
      scroll: { x: 1500 }, //滚动设置
      formLayout: 'horizontal',
      tableData: [],
      pageData: {
        showTotal: total => `总共 ${total} 条`, //展示总条数
      },
      url: '',
      companyId: this.$route.params.id,
      companyCode: '',
      // 弹窗相关
      form: this.$form.createForm(this),
      visible: false,
      fileList: [],
      defaultFileList: [],
      btnText: '选取文件',
    }
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    //获取table数据
    async _getTableData() {
      this.loading = true
      const { current, pageSize } = this.pageData
      const query = {
        companyCode: this.company.code,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getAttachment(query)

        this.tableData = records
        this.pageData.total = total
        this.loading = false
      } catch (err) {
        console.log(err)
      }
    },
    //分页
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)

      this._getTableData()
    },
    showModal() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
      this.handleAfterClose()
    },
    //抵押和担保下载
    _download(id) {
      try {
        downloadRequest(id)
      } catch (err) {
        console.log(err)
      }
    },
    //抵押和担保上传
    uploadChange(data) {
      const {
        file: { response },
      } = data
      if (!response) {
        return
      }
      if (response && response.code === '0000') {
        this.$message.success('成功')
        this._getTableData()
      } else {
        if (response && response.code == LOGIN_EXPIRED) {
          // 此时登录过期
          this.$message.error('登录过期，请重新登录')
          window.setTimeout(() => {
            storage.clear()
            this.$router.push('/login')
          }, 1000)
        } else {
          this.$message.error((response && response.message) || '操作失败')
        }
      }
    },
    async handleDel(id) {
      try {
        await deleteRequest(id)
        this._getTableData()
      } catch (err) {
        console.log(err)
      }
    },
    // 提交和编辑
    handleSubmit() {
      if (!this.fileList || !this.fileList.length) {
        this.$notification.warn({
          message: '提示',
          description: '请上传文件',
        })
        return
      }
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const { fileList } = this

          try {
            const { message } = await addDocument({
              ...values,
              file: fileList,
              companyCode: this.company.code,
            })
            this.handleCancel()

            this.$notification.success({
              message: '提示',
              description: message,
            })
            this._getTableData()
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 弹窗关闭
    handleAfterClose() {
      this.fileList = []
      this.defaultFileList = []
    },
    // 上传之前
    handleBeforeUpload(file) {
      this.fileList = [...this.fileList, file]
      return false
    },

    handleRemove() {
      this.fileList = []
    },
    handleFileChange() {
      if (this.fileList.length > 1) {
        this.fileList.shift()
      }
    },
    // 本地删除
    remove(index) {
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
  },
}
</script>
<style lang="less" scoped>
#components-a-tooltip-demo-placement .ant-btn {
  width: 70px;
  text-align: center;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>
